export default class UserInGroup {
    constructor(id, name, active, requiresTTApproval) {
        this.id = id;
        this.name = name;
        this.active = active;
        this.requiresTTApproval = requiresTTApproval;
    }
}



// WEBPACK FOOTER //
// ./web/js/groupManagement/entities/UserInGroup.js